import React from "react";
import * as FaIcons from "react-icons/fa";
import countriesList from "../../../data/countriesList";
import states from "../../../data/states";

const R5MailingAddress = ({ formData, onFormDataChange, validationCheck }) => {
  const {
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCountry ,
  } = formData;
  return (
    <>
      {/* Mailing Addess */}
      {isMailingAddressTheSame["no"] && (
        <>
          <div className="sub-form">
            <h3>Mailing Address</h3>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Mailing Street</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="mailingStreet"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={mailingStreet}
                style={{
                  border:
                    validationCheck && !(mailingStreet !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Mailing City</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="mailingCity"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={mailingCity}
                style={{
                  border:
                    validationCheck && !(mailingCity !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Mailing State</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="mailingState"
                value={mailingState}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(mailingState !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {states.map((item) => {
                  return (
                    <option value={Object.keys(item)}>
                      {Object.keys(item)}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Mailing Zip</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="mailingZip"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={mailingZip}
                style={{
                  border:
                    validationCheck && !(mailingZip !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="item">
                <div className="asterisk-group">
                  <h3> Mailing Country</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="mailingCountry"
                  value={mailingCountry}
                  type="text"
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border:
                      validationCheck && !(mailingCountry !== "")
                        ? "2px solid #d8302f"
                        : "",
                  }}
                  >
                  <option value="">Please Select </option>
                  {countriesList.map((item) => {
                    return <option value={item}>{item}</option>;
                  })}
                </select>
              </div>
          </div>
        </>
      )}
    </>
  );
};

export default R5MailingAddress;
